import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UpdatePeripheralsComponent } from '../../../Dialogs/update-peripherals/update-peripherals.component';

@Component({
  selector: 'app-button-cell-renderer',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <button style="border: none; background: transparent; cursor: pointer; margin-right: 15px;margin-top:6px;" (click)="onEditClick()">
      <mat-icon>edit</mat-icon>
    </button>
    <button style="border: none; background: transparent; cursor: pointer; color: black;margin-top:6px;" (click)="onDeleteClick()">
      <mat-icon>delete</mat-icon>
    </button>
  `
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
  private params: any;

  constructor(private dialog: MatDialog) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onEditClick(): void {
    this.dialog.open(UpdatePeripheralsComponent, {
      width: '600px',
      data: this.params.node.data,
      closeOnNavigation: false,
    });
  }

  onDeleteClick(): void {
    if (this.params?.onDelete && typeof this.params.onDelete === 'function') {
      this.params.onDelete(this.params.node.data);
    }
  }
} 
